if (!customElements.get('popup-image-slider')) {
  document.addEventListener('click', event => {
    const section = event.target.closest('.product-list-pop-up-section');
    if (!section) return;
    const link = event.target.closest('.product-link[data-product-id]');
    if (link) {
      const popup = [...section.querySelectorAll('.product-popup')].find(item => item.id === `product-popup-${link.dataset.productId}`);
      if (!popup) return;
      event.preventDefault();
      popup.style.display = 'flex';
      document.body.classList.add('popup-open');
      popup.querySelector('.popup-close')?.focus();
      popup.returnFocus = link;
      return;
    }
    const popup = event.target.closest('.product-popup');
    if (popup && (event.target.closest('.popup-close') || event.target === popup.querySelector('.popup-overlay'))) {
      popup.style.display = 'none';
      document.body.classList.remove('popup-open');
      popup.returnFocus?.focus();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.product-list-pop-up-section .product-popup').forEach(popup => {
      if (getComputedStyle(popup).display === 'none') return;
      popup.style.display = 'none';
      document.body.classList.remove('popup-open');
      popup.returnFocus?.focus();
    });
  });
  customElements.define('popup-image-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.popup = this.closest('.product-popup');
      this.index = 0;
      this.timer = null;
      this.open = false;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.querySelector('[data-previous]')?.addEventListener('click', () => this.change(-1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.change(1), options);
      this.querySelector('[data-pause]')?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updatePause();
        this.schedule();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.change(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', event => {
        if (event.matches) this.paused = true;
        this.updatePause();
        this.schedule();
      }, options);
      this.observer = new MutationObserver(() => this.sync());
      if (this.popup) this.observer.observe(this.popup, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      this.updatePause();
      this.sync();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
    }
    sync() {
      const open = !!this.popup && !this.popup.hidden && getComputedStyle(this.popup).display !== 'none';
      if (open && !this.open) { this.index = 0; this.show(); }
      this.open = open;
      this.schedule();
    }
    change(direction) {
      if (this.slides.length < 2) return;
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      this.show();
      this.schedule();
    }
    show() {
      this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
      const counter = this.querySelector('[data-counter]');
      if (counter) counter.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    updatePause() {
      const button = this.querySelector('[data-pause]');
      if (!button) return;
      button.textContent = this.paused ? '▶' : 'Ⅱ';
      button.setAttribute('aria-label', this.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    }
    schedule() {
      clearTimeout(this.timer);
      this.timer = null;
      if (!this.open || this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.focused || document.hidden) return;
      const seconds = Math.min(15, Math.max(2, Number(this.dataset.interval) || 5));
      this.timer = setTimeout(() => this.change(1), seconds * 1000);
    }
  });
}
